import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PromotionalBanners = () => {
  const { t } = useTranslation();

  const banners = [
    {
      key: 'fresh_drinks',
      to: '/categories',
      image: '/images/categories/fruit.png',
      gradient: 'from-[#E5502E] to-[#8A250E]',
      imageAlign: 'justify-start',
    },
    {
      key: 'men_shoes',
      to: '/categories',
      image: '/images/categories/chaussures.png',
      gradient: 'from-[#0E8A5D] via-[#54E5A7] to-teal-300',
      imageAlign: 'justify-end',
    },
    {
      key: 'headphones',
      to: '/promotions',
      image: '/images/categories/ecouteurs.png',
      gradient: 'from-[#8A4600] to-[#FEA244]',
      imageAlign: 'justify-end',
      className: 'sm:col-span-2 lg:col-span-1',
      imageExtraClass: 'xl:w-32 xl:h-32',
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {banners.map((banner) => (
            <Link
              key={banner.key}
              to={banner.to}
              className={`relative overflow-hidden rounded-xl bg-gradient-to-r ${banner.gradient} p-4 sm:p-6 h-32 sm:h-36 md:h-40 flex items-center hover:opacity-95 transition-opacity ${banner.className || ''}`}
            >
              <div className="flex-1 text-left text-white z-10">
                <h3 className="text-base xl:text-lg font-bold mb-2 sm:mb-3 md:mb-4 leading-tight">
                  {t(`home.promotional_banners.${banner.key}.title`)}
                </h3>
                <span className="text-xs text-left sm:text-sm hover:underline transition-colors flex items-center gap-1">
                  {t(`home.promotional_banners.${banner.key}.cta`)}
                </span>
              </div>

              <div className={`flex-1 flex ${banner.imageAlign} items-center`}>
                <div className="relative">
                  <img
                    src={banner.image}
                    alt={t(`home.promotional_banners.${banner.key}.title`)}
                    className={`w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain ${banner.imageExtraClass || ''}`}
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromotionalBanners;
